// 返回url的参数
export const getUrlParams = (search: string, query: string) => {
  if (search === "") return "";
  let searchArr = search.split("&");
  for (let i = 0; i < searchArr.length; i++) {
    let item = searchArr[i].indexOf(query);
    if (item !== -1) {
      return searchArr[i].split("=")[1];
    }
  }
  return "";
};
